import styled from 'styled-components'
import { Grid } from '@mui/material'
import { defaultTheme } from '../../../../../src/theme'

export const StyledGridTitle = styled(Grid)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
`

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-top: 1px solid ${defaultTheme.colors.borderTable};

  @media only screen and(max-width: 480px) {
    display: none;
  }
`
